
    <div
      fieldmagicGridRow
      [attr.id]="id"
    >
      <ng-content></ng-content>
    </div>
  